import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';

// Styles
import { SmartContainer, Stack, Surface, StyledStyledSideBarContainer } from '../../../styles/Containers'

// Components
import { FormInput } from '../../../components/Forms/FormInput';
import { PublishingForm } from '../../../components/Publishing/PublishingForm';


// Redux
import { AssetSelect } from '../Assets/AssetSelect';
import { FullViews } from './redux/views.selectors';
import { deleteView, duplicateView, updateView } from './redux/views.actions';
import { Checkbox } from '../../../components/Forms/Checkbox';
import { StyledB, StyledP } from '../../../styles/StyledHTML';
import { CurrentNetwork, FullNetwork } from '../../../redux/Network/network.selectors';
import { TagEditor } from '../../../components/Taxonomy/TagEditor';
import { FullLibraries } from '../Library/redux/library.selectors';
import { replaceLibraryTags, searchLibrary } from '../Library/redux/library.actions';
import { TagSelector } from '../../../components/Taxonomy/TagSelector';
import { FullAlbums } from '../Album/redux/album.selectors';
import { FullLocations } from '../Location/redux/locations.selectors';
import { FullPeople } from '../People/redux/people.selectors';
import { FullGenericTags } from '../GenericTags/redux/generictags.selectors';
import { searchAlbum } from '../Album/redux/album.actions';
import { searchLocations } from '../Location/redux/locations.actions';
import { searchGenericTags } from '../GenericTags/redux/generictags.actions';
import { searchPeople } from '../People/redux/people.actions';
import { AndOr } from '../../components/Search/AndOr';
import { TERM_ALBUM_PLURAL, TERM_LIBRARY_PLURAL } from '../../services/CaptureCollabService';

// ---------------------------
// Edit Example Taxonomy Form
// ---------------------------

export const EditViewForm = ({ item, childrenMain, childrenSide, trigger }) => {

    const dispatch = useDispatch();
    const store = FullViews();
    const thisNetwork = CurrentNetwork();


    // Name
    const [name, setName] = useState('');
    const [formattedFilters, setFormattedFilters] = useState(null);
    const [coverPhoto, setCoverPhoto] = useState('');
    const [sharable, setSharable] = useState(false);

    // Validate
    let disableSubmit = !name;

    const storeLibraries = FullLibraries();
    const storeAlbums = FullAlbums();
    const storeLocations = FullLocations();
    const storePeople = FullPeople();
    const storeTags = FullGenericTags();


    // Load Libraries
    const loadLibraries = () => {
        const args = {}
        dispatch(searchLibrary(0, null, null, 'all', { prefix: 'fulldataset' }))
    }

    // Load Albums
    const loadAlbums = () => {
        const args = {}
        dispatch(searchAlbum(0, null, null, 'all', { prefix: 'fulldataset' }))
    }

    // Load Locations
    const loadLocations = () => {
        const args = {}
        dispatch(searchLocations(0, null, null, 'all', { prefix: 'fulldataset' }))
    }

    // Load Tags
    const loadGenericTags = () => {
        dispatch(searchGenericTags(0, null, null, 'all', { prefix: 'fulldataset' }))
    }

    // Load Tags
    const loadPeople = () => {
        dispatch(searchPeople(0, null, null, 'all', { prefix: 'fulldataset' }))
    }

    // ---------------------------
    // Effects
    // ---------------------------

    const parseFilters = (filters) => {
        const f = {};
        const x = Object.keys(filters).map(key => {

            if (key !== 'appendResults' && filters[key] && filters[key].length > 0) {
                f[key] = filters[key]
            }
            return key
        })
        return f;
    }

    const formatFiltersForSave = (filters) => {
        const f = {}

        const x = Object.keys(filters).map(key => {
            if (key !== 'appendResults' && filters[key] && filters[key].length > 0) {
                f[key] = JSON.parse(JSON.stringify(filters[key]));
            }
            return key
        })

        return f;
    }

    const encodeFilters = (filters) => {

        const fom = {}
        if (!filters) return;

        const x = Object.keys(filters)?.map(key => {

            if (filters[key].length > 0) {
                if (key.indexOf('Compare') > 0) {
                    fom[key] = filters[key];
                } else {
                    fom[key] = JSON.stringify(filters[key]);
                }
            }
            return key;
        })
        return fom;

    }


    const formatTags = (tags) => {
        if (!tags) {
            return [];
        }
        return tags?.map(v => { return { id: v } })
    }

    // Sync Props
    useEffect(() => {

        // Get Libraries
        loadLibraries();

        // Get Albums 
        loadAlbums();

        // Get Locations 
        loadLocations();

        // Get Generic Tags
        loadGenericTags();

        // Get People
        loadPeople();

        // ---------
        // Set Data
        // ---------

        if (item?.name) setName(item.name);
        else setName('')

        if (item?.meta?.filters) {
            const f = parseFilters(item.meta.filters);
            setFormattedFilters(f);
        } else setFormattedFilters('')

        if (item?.meta?.coverPhoto) setCoverPhoto(item.meta.coverPhoto);
        else setCoverPhoto('');

        if (item?.meta?.sharable) setSharable(item.meta.sharable);
        else setSharable('');

    }, [item])



    // --------------------------
    // Interactions
    // --------------------------

    const handleChange = (model, tags) => {
        const m = { ...formattedFilters };
        m[model] = tags?.map(i => { return i.id });
        setFormattedFilters(m);
    }

    const handleCompareChange = (k, v) => {
        const m = { ...formattedFilters };
        m[k] = v;
        setFormattedFilters(m);
    }
    const handleSubmit = (publishing) => {

        const filters = formatFiltersForSave(formattedFilters);

        // Payload
        const payload = {
            name,
            status: publishing.status,
            publishedAt: publishing.publishedAt,
            unpublishedAt: publishing.unpublishedAt,
            meta: {
                coverPhoto,
                filters,
                sharable
            }
        }
        dispatch(updateView(item.id, payload));
    }

    // --------------------------
    // Slots
    // --------------------------

    const renderMainContentChildren = () => {
        if (!childrenMain) return (<div></div>)
        return (<SmartContainer>{childrenMain}</SmartContainer>)
    }

    const renderSideContentChildren = () => {
        if (!childrenSide) return (<div></div>)
        return (<SmartContainer>{childrenSide}</SmartContainer>)
    }

    // --------------------------
    // Render Form
    // --------------------------
    if (!item) return (<p>Loading...</p>)

    return (
        <StyledStyledSideBarContainer thinking={store?.createLoading || store?.updateLoading || store?.duplicateLoading} minWidth="300px">
            <Stack>
                <Surface>
                    <Stack>
                        <FormInput label="Name" type="text" onChange={setName} value={name} />
                        <AssetSelect label="Cover Photo" buttonText="Browse Photos" onChange={setCoverPhoto} filters={encodeFilters(formattedFilters)} value={coverPhoto} />
                        <SmartContainer><Checkbox label="Make this publically sharable " value={sharable} onChange={setSharable} color="primary" /></SmartContainer>

                        {sharable && (
                            <SmartContainer>
                                <StyledP light small>Enabling Public Share links will make the photos that match this view available to anyone that has the link.</StyledP>
                                <StyledP small>https://{thisNetwork.domain}/viewer/{item?.id}</StyledP>
                            </SmartContainer>
                        )}
                    </Stack>
                </Surface>

                <StyledP>Update Search Tags</StyledP>

                {formattedFilters && (


                    <Surface>
                        <Stack>
                            <SmartContainer>
                                <StyledP>{TERM_LIBRARY_PLURAL} <AndOr value={(formattedFilters?.LibraryCompare) ? formattedFilters?.LibraryCompare : 'OR'} onChange={(v) => handleCompareChange('LibraryCompare', v)} /></StyledP>
                                <TagSelector
                                    inputLabel={TERM_LIBRARY_PLURAL}
                                    existingOptions={formatTags(formattedFilters?.Library)}
                                    options={storeLibraries?.fulldataset?.rows}
                                    onChange={(v) => handleChange('Library', v)}
                                    helperText={`Restrict results to a set of ${TERM_LIBRARY_PLURAL}`}
                                />
                            </SmartContainer>
                            <SmartContainer>
                                <StyledP>{TERM_ALBUM_PLURAL} <AndOr value={(formattedFilters?.AlbumCompare) ? formattedFilters?.AlbumCompare : 'OR'} onChange={(v) => handleCompareChange('AlbumCompare', v)} /></StyledP>
                                <TagSelector
                                    inputLabel={TERM_ALBUM_PLURAL}
                                    existingOptions={formatTags(formattedFilters?.Album)}
                                    options={storeAlbums?.fulldataset?.rows}
                                    onChange={(v) => handleChange('Album', v)}
                                    helperText={`Restrict results to a set of ${TERM_ALBUM_PLURAL}`}
                                />
                            </SmartContainer>
                            <SmartContainer>
                                <StyledP>Locations <AndOr value={(formattedFilters?.LocationCompare) ? formattedFilters?.LocationCompare : 'OR'} onChange={(v) => handleCompareChange('LocationCompare', v)} /></StyledP>
                                <TagSelector
                                    inputLabel="Locations"
                                    existingOptions={formatTags(formattedFilters?.Location)}
                                    options={storeLocations?.fulldataset?.rows}
                                    onChange={(v) => handleChange('Location', v)}
                                    helperText="Restrict results to a set of locations"
                                />
                            </SmartContainer>
                            <SmartContainer>
                                <StyledP>People <AndOr value={(formattedFilters?.PersonCompare) ? formattedFilters?.PersonCompare : 'OR'} onChange={(v) => handleCompareChange('PersonCompare', v)} /></StyledP>
                                <TagSelector
                                    inputLabel="People"
                                    existingOptions={formatTags(formattedFilters?.Person)}
                                    options={storePeople?.fulldataset?.rows}
                                    onChange={(v) => handleChange('Person', v)}
                                    helperText="Restrict results to a set of people"
                                />
                            </SmartContainer>
                            <SmartContainer>
                                <StyledP>Tags <AndOr value={(formattedFilters?.GenericTagCompare) ? formattedFilters?.GenericTagCompare : 'OR'} onChange={(v) => handleCompareChange('GenericTagCompare', v)} /></StyledP>
                                <TagSelector
                                    inputLabel="Tags"
                                    existingOptions={formatTags(formattedFilters?.GenericTag)}
                                    options={storeTags?.fulldataset?.rows}
                                    onChange={(v) => handleChange('GenericTag', v)}
                                    helperText="Restrict results to a set of tags"
                                />
                            </SmartContainer>
                        </Stack>
                    </Surface>
                )}
                {renderMainContentChildren()}
            </Stack>
            <SmartContainer>
                <Stack>

                    <PublishingForm
                        item={item}
                        onSubmit={handleSubmit}
                        disable={disableSubmit}
                        deleteAction={deleteView}
                        duplicateAction={duplicateView}
                        selector={FullViews}
                        route="/views"
                        withDuplicate={false}
                        withScheduling={true}
                        trigger={trigger}
                        hideSave={true}
                    />


                    {renderSideContentChildren()}
                </Stack>

            </SmartContainer>
        </StyledStyledSideBarContainer>
    )
}